// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { RequestDemoPage } from '../pages/RequestDemoPage/RequestDemoPage';

export const Route = createFileRoute('/contact-sales')({
  component: RequestDemoPage,
});
